<template>
  <v-row>
    <v-col cols="12">
      <v-card class="mb-4">
        <v-card-title>Επιλεγμένα Προϊόντα</v-card-title>
        <v-card-text>
          <v-alert outlined type="info" color="grey" class="mt-2">
            Επιβεβαιώστε ότι τα επιλεγμένα προϊόντα είναι σωστά και προχωρήστε στην έκδοση.
          </v-alert>
          <v-btn
            color="grey"
            rounded
            outlined
            class="px-6 mr-2"
            @click="$emit('go-to-step', 1)"
          >
            <v-icon left>mdi-chevron-left</v-icon>
            ΟΛΑ ΤΑ ΠΡΟΙΟΝΤΑ
          </v-btn>
        </v-card-text>
        <v-list>
          <SDAProductItem
            v-for="item in selectedSDAItems"
            :key="item.PartnerMvItm_ID"
            :item="item"
            :selected-quantity="selectedItems[item.PartnerMvItm_ID] || 0"
            :disabled="false"
            :only-show-s-d-a-inv="false"
            @info-click="$emit('info-click', $event)"
            @increment="$emit('increment', $event)"
            @decrement="$emit('decrement', $event)"
            @quantity-change="$emit('quantity-change', $event, arguments[1])"
          />
        </v-list>
        <v-card-text>
          <v-textarea
            :value="notes"
            @input="$emit('notes-change', $event)"
            label="Σημειώσεις"
            outlined
            hide-details
            class="mt-4"  
          />
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import SDAProductItem from './SDAProductItem.vue'

export default {
  name: 'SDASelectedProducts',
  components: {
    SDAProductItem
  },
  props: {
    selectedSDAItems: {
      type: Array,
      default: () => []
    },
    selectedItems: {
      type: Object,
      default: () => ({})
    },
    notes: {
      type: String,
      default: ''
    }
  }
}
</script> 